import React, { useEffect, useState } from 'react';

import Frame from '../frame';
import Style from './style';
import TradeRelationShip from '../../../../../../../components/dashboards/components/TradeRelationShip';
import { CloseOutlined } from '@ant-design/icons';
import { actions } from '../../../../../../../store/reducers/dashboard';
import { useDispatch } from 'react-redux';
import Loader from '../loader';

const TradeRelationships = ({
  trade,
  t = (t) => t,
  language,
  canFetch = false,
  selectedProject,
  sourceId,
}) => {
  const [emptyStateIsShown, setEmptyStateIsShown] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (canFetch) {
      dispatch(actions.PmeDashboardGetWithFilters({
        widget: 'trade',
      }));
    }
  }, [language, canFetch, selectedProject, sourceId]);

  return <Frame title={t('Trade Relationships')}>
    <Style className="w-100 h-100">
      <div
        className="row between"
        style={{
          height: '100%',
          flex: 1,
          padding: '0',
          margin: '0',
        }}
      >
        <TradeRelationShip
          emptyStateIsShown={emptyStateIsShown}
          setEmptyStateIsShown={setEmptyStateIsShown}
          module="pme"
          trade={trade}
          loadGraph={true}
          sourceId={sourceId}
          selectedProject={selectedProject}
        />
      </div>
      {emptyStateIsShown && (
        <div className="empty-state">
          <div className="header">
            <div className="cont content">
              <div><h1>👋 {t('Hi There')}!</h1></div>
            </div>
            <div className="cont close-cont">
              <CloseOutlined
                onClick={() => setEmptyStateIsShown(false)}
              />
            </div>
          </div>
          <div className="body">
            <p>{t('TradeRelationshipMessage')}</p>
          </div>
        </div>
      )}
    </Style>
    {!trade ? (
      <Loader />
    ) : null}
  </Frame>;
}

export default TradeRelationships;
